import {
    QueryFunction,
    QueryKey,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    useQuery,
    UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
    EventsApiService,
} from 'features/events/api/events-api.service';

import { eventsQueryKeys } from './query-keys';


const { getEventsCouponDropDown } = EventsApiService();

const getEventsQuery = (
    // flag: string,
    params: any,
    options?: UseQueryOptions<any>,
): {
    queryKey: QueryKey;
    queryFn: QueryFunction<any>;
    options?: UseQueryOptions<any>;
} => ({
    queryKey: eventsQueryKeys.list(params),
    queryFn: ({ signal }) => getEventsCouponDropDown(params, { config: { signal } }),
    ...options,
});

export const useGetDropDownCommonCoupon = (
    // flag: string,
    params: any,
    options?: UseQueryOptions<any>,
) => {
    const { message } = App.useApp();

    return useQuery<any, Error>(
        getEventsQuery(params, {
            onError: (error: unknown) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            ...options,
        }),
    );
};

export const useGetEventsInfiniteQuery = (
    params: any,
    options?: UseInfiniteQueryOptions<any>,
) => {
    const { message } = App.useApp();

    return useInfiniteQuery({
        queryKey: eventsQueryKeys.list(params),
        queryFn: ({ signal, pageParam }) =>
            getEventsCouponDropDown(
                { ...params, page: pageParam || params.page },
                { config: { signal } },
            ),
        getNextPageParam: (lastPage) => {
            const hasMorePages = lastPage.pages > lastPage.page;

            return hasMorePages ? lastPage.page + 1 : undefined;
        },
        onError: (error: unknown) => {
            const uiMessage = handleError(error);

            message.error(uiMessage);
        },
        ...options,
    });
};
